// Small unread-count badge used on the Inbox nav icons (mobile tab bar + left rail).
export default function UnreadDot({ count, className = "", testId = "inbox-unread-badge" }) {
  if (!count) return null;
  return (
    <span data-testid={testId} aria-label={`${count} unread messages`}
      className={`absolute -top-1 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-rose-600 text-white text-[9px] font-bold leading-4 text-center animate-[pulse_1.6s_ease-in-out_3] ${className}`}>
      {count > 99 ? "99+" : count}
    </span>
  );
}
